module.exports = __webpack_public_path__ + "media/img/home/directions/list-6-126e687e6f67da96ea5a7d7367e89ca6.svg";